import Home from '@/components/Home';

// 师资管理
const teacherManagement = () => import('@/pages/trainingManagement/teacherManagement');
const addTeacher = () => import('@/pages/trainingManagement/addTeacher');


const trainingResource = () => import('@/pages/trainingManagement/trainingResource');
const addProgram = () => import('@/pages/trainingManagement/addProgram');
const latojaManagement = () => import('@/pages/trainingManagement/latojaManagement');


// training task
const trainingTask = () => import('@/pages/trainingManagement/task/trainingTask');
const publishTask = () => import('@/pages/trainingManagement/task/publishTask');
const selectCourse = () => import('@/pages/trainingManagement/task/selectCourse');

const trainingResourceDetail = () => import('@/pages/trainingManagement/trainingResourceDetail');
const trainingDetail = () => import('@/pages/trainingManagement/trainingDetail');
const addLatoja = () => import('@/pages/trainingManagement/addLatoja');
const examInfo = () => import('@/pages/trainingManagement/examInfo');
const questionBankManagenment = () => import('@/pages/examination/questionBankManagenment');
const paperManagement = () => import('@/pages/examination/paperManagement');
const examManagement = () => import('@/pages/examination/examManagement');
const examStatistics = () => import('@/pages/examination/examStatistics');
const issueExam = () => import('@/pages/examination/issueExam');
const directory = () => import('@/pages/trainingManagement/directory');
const examStatisticsDetail = () => import('@/pages/examination/examStatisticsDetail');
const addPaper = () => import('@/pages/examination/addPaper');
const addQuestion = () => import('@/pages/examination/addQuestion');

// 课程管理
const courseManagement = () => import('@/pages/trainingManagement/course/courseManagement');
const addCourse = () => import('@/pages/trainingManagement/course/addCourse');



// 安全培训计划
const safetyTrainingProgramList = () => import('@/pages/trainingManagement/safetyTrainingProgram/list.vue');
const safetyTrainingProgramSave = () => import('@/pages/trainingManagement/safetyTrainingProgram/save.vue');
const safetyTrainingProgramDetails = () => import('@/pages/trainingManagement/safetyTrainingProgram/details.vue');

//培训对象(线上)
const trainingObject = () => import('@/pages/trainingManagement/safetyTrainingProgram/component/trainingObject.vue');

//培训对象(线下)
const offlineTrainingObjects = () => import('@/pages/trainingManagement/safetyTrainingProgram/component/offlineTrainingObjects.vue');

// 学员前端
const myTrain = () => import('@/pages/student/myTrain');
const myExam = () => import('@/pages/student/myExam');
const train = () => import('@/pages/student/train');
const exam = () => import('@/pages/student/exam');
const lookExam = () => import('@/pages/student/lookExam');


//  档案管理
const archivesEnterprise = () => import('@/pages/trainingManagement/archives/enterprise/index.vue');

// 一期一档列表页面
const osofList = () => import('@/pages/trainingManagement/archives/osof/osofList.vue');
const osofDir = () => import('@/pages/trainingManagement/archives/osof/osofDir.vue');


//企业开放课程
const entOpenCourse = () => import('@/pages/trainingManagement/entOpenCourse/index.vue');
const entOpentPlay = () => import("@/pages/trainingManagement/entOpenCourse/play.vue");

export default [{
  path: '/',
  component: Home,
  name: '新培训管理',
  menuShow: true,
  leaf: true,
  children: [
    {
      path: '/trainingManagement/trainingResource',
      component: trainingResource,
      name: '培训资源管理',
      menuShow: true
    },
    {
      path: '/trainingManagement/latojaManagement',
      component: latojaManagement,
      name: '线下培训管理',
      menuShow: true
    },
    {
      path: '/trainingManagement/safetyTrainingProgramList',
      component: safetyTrainingProgramList,
      name: '安全培训计划',
      menuShow: true
    },
    {
      path: '/trainingManagement/safetyTrainingProgramSave',
      component: safetyTrainingProgramSave,
      name: '安全培训计划',
      menuShow: true
    },
    {
      path: '/trainingManagement/safetyTrainingProgramEdit',
      component: safetyTrainingProgramSave,
      name: '编辑安全培训计划',
      menuShow: true
    },
    {
      path: '/safetyTrainingProgram/details',
      component: safetyTrainingProgramDetails,
      name: '计划详情',
      menuShow: true
    },
    {
      path: '/safetyTrainingProgram/details/trainingObject',
      component: trainingObject,
      name: '培训对象',
      menuShow: true
    },
    {
      path: '/safetyTrainingProgram/details/offlineTrainingObjects',
      component: offlineTrainingObjects,
      name: '培训对象',
      menuShow: true
    },
    {
      path: '/trainingManagement/trainingTask',
      component: trainingTask,
      name: '培训任务',
      menuShow: true
    },
    {
      path: '/trainingManagement/offlineTrainingTasks',
      component: resolve => require(['@/pages/trainingManagement/safetyTrainingProgram/component/offlineTrainingTasks'], resolve),
      name: '线下培训任务',
      menuShow: true
    },
    {
      path: '/trainingManagement/trainingResourceDetail',
      component: trainingResourceDetail,
      name: '课件详情',
      menuShow: true
    },
    {
      path: '/trainingManagement/trainingResourceAdd',
      component: trainingResourceDetail,
      name: '新增课件',
      menuShow: true
    },
    {
      path: '/trainingManagement/trainingResourceUpdate',
      component: trainingResourceDetail,
      name: '编辑课件',
      menuShow: true
    },
    {
      path: '/trainingManagement/addProgram',
      component: addProgram,
      name: '添加培训计划',
      menuShow: true
    },
    {
      path: '/trainingManagement/task/publishTask',
      component: publishTask,
      name: '下发任务',
      menuShow: true
    },
    {
      path: '/trainingManagement/task/selectCourse',
      component: selectCourse,
      name: '选择下发课程',
      menuShow: true
    },
    {
      path: '/trainingManagement/trainingDetail',
      component: trainingDetail,
      name: '培训任务详情',
      menuShow: true
    },
    {
      path: '/trainingManagement/addLatoja',
      component: addLatoja,
      name: '添加线下培训',
      menuShow: true
    },
    {
      path: '/trainingManagement/detailLatoja',
      component: addLatoja,
      name: '线下培训详情',
      menuShow: true
    },
    {
      path: '/trainingManagement/updateLatoja',
      component: addLatoja,
      name: '编辑线下培训',
      menuShow: true
    },
    {
      path: '/trainingManagement/examInfo',
      component: examInfo,
      name: '关联考试信息',
      menuShow: true
    },
  ]
}, {
    path: '/',
    component: Home,
    name: '安全教育考试',
    menuShow: true,
    leaf: true,
    children: [{
      path: '/examination/questionBankManagenment',
      component: questionBankManagenment,
      name: '题库管理',
      menuShow: true
    },
      {
        path: '/examination/paperManagement',
        component: paperManagement,
        name: '试卷管理',
        menuShow: true
      },
      {
        path: '/examination/examManagement',
        component: examManagement,
        name: '考试管理',
        menuShow: true
      },
      {
        path: '/examination/examStatistics',
        component: examStatistics,
        name: '考试统计',
        menuShow: true
      },
      {
        path: '/examination/examStatisticsDetail',
        component: examStatisticsDetail,
        name: '考试统计详情',
        menuShow: true
      },
      {
        path: '/examination/addPaper',
        component: addPaper,
        name: '试卷信息',
        menuShow: true
      },
      {
        path: '/examination/addQuestion',
        component: addQuestion,
        name: '新建题库',
        menuShow: true
      },
      ,
      {
        path: '/examination/detailQuestion',
        component: addQuestion,
        name: '题库详情',
        menuShow: true
      },
      ,
      {
        path: '/examination/updateQuestion',
        component: addQuestion,
        name: '编辑题库',
        menuShow: true
      },
      {
        path: '/examination/issueExam',
        component: issueExam,
        name: '发布考试',
        menuShow: true
      }, {
        path: '/examination/directory',
        component: directory,
        name: '目录',
        menuShow: true
      }, {
        path: '/trainingManagement/teacherManagement',
        component: teacherManagement,
        name: '师资管理',
        menuShow: true
      }, {
        path: '/trainingManagement/detailTeacher',
        component: addTeacher,
        name: '师资信息',
        menuShow: true
      },
      {
        path: '/trainingManagement/addTeacher',
        component: addTeacher,
        name: '新建师资',
        menuShow: true
      },
      {
        path: '/trainingManagement/updateTeacher',
        component: addTeacher,
        name: '编辑师资',
        menuShow: true
      },{
        path: '/examination/course/courseManagement',
        component: courseManagement,
        name: '课程管理',
        menuShow: true
      }, {
        path: '/examination/course/addCourse',
        component: addCourse,
        name: '新增课程',
        menuShow: true
      }, {
        path: '/examination/course/updateCourse',
        component: addCourse,
        name: '编辑课程',
        menuShow: true
      }, {
        path: '/examination/course/detailCourse',
        component: addCourse,
        name: '课程信息',
        menuShow: true
      },
    ]
  },{
    path: '/',
    component: Home,
    name: '档案管理',
    menuShow: true,
    leaf: true,
    children: [
      {
        path: '/archives/ent',
        component: archivesEnterprise,
        name: '企业档案',
        menuShow: true
      },
      {
        path: '/archives/osof/list',
        component: osofList,
        name: '一期一档',
        menuShow: true
      },
      {
        path: '/archives/osof/dir',
        component: osofDir,
        name: '一期一档:档案目录',
        menuShow: true
      }
    ]
  },
  {
    path: '/',
    component: Home,
    name: '学员',
    menuShow: true,
    leaf: true,
    children: [{
      path: '/student/myTrain',
      component: myTrain,
      name: '我的培训',
      menuShow: true
    },
      {
        path: '/student/myExam',
        component: myExam,
        name: '我的考试',
        menuShow: true
      },
    ]
  },
  {
    path: '/student/train',
    component: train,
    name: '开始学习',
    leaf: true,
    menuShow: true
  },
  {
    path: '/student/exam',
    component: exam,
    name: '开始考试'
  },
  {
    path: '/student/lookExam',
    component: lookExam,
    name: '查看试卷'
  },

  {
    path: '/',
    component: Home,
    name: '开放资源',
    menuShow: true,
    leaf: true,
    children: [
      //开放课程
      {
        path: '/ent-open/course',
        component: entOpenCourse,
        name: '开放课程',
        menuShow: true
      },
      //播放视频 （针对开放课程）
      {
        path: '/ent-open/play',
        component: entOpentPlay,
        name: '视频播放',
        menuShow: true
      }
    ]
  },
  {
    path: '/',
    component: Home,
    name: '预警管理',
    menuShow: true,
    leaf: true,
    children: [
      {
        path: '/warningModuleSetting',
        component: () => import('@/pages/EarlyWarningManagement/Tpl'),
        name: '预警模板设置',
        menuShow: true
      },
      {
        path: '/warningDetail',
        component: () => import('@/pages/EarlyWarningManagement/Detail'),
        name: '预警详情',
        menuShow: true
      },
      {
        path: '/ewarning/sms',
        component: () => import('@/pages/EarlyWarningManagement/Sms'),
        name: '短信充值',
        menuShow: true
      },
      {
        path: '/ewarning/order',
        component: () => import('@/pages/EarlyWarningManagement/Order'),
        name: '充值订单',
        menuShow: true
      },
    ]
  },
  {
    path: '/',
    component: Home,
    name: '权限管理',
    menuShow: true,
    leaf: true,
    children: [
      {
        path: '/warningBuildTemp',
        component: () => import('@/pages/AuthManagement/Sys'),
        name: '系统内置模板',
        menuShow: true
      },
      {
        path: '/builtInAlert',
        component: () => import('@/pages/AuthManagement/Warning'),
        name: '预警内置对象',
        menuShow: true
      }
    ]
  },
  
]



// WEBPACK FOOTER //
// ./src/router/newRouter.js